import React from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

export default function RetellSubmitButton({ submitEnabled, onSubmit }) {
  return (
    <AmiraIconButton
      type={ICON_BUTTON_TYPES.SUBMIT}
      oblong
      onClick={() => submitEnabled && onSubmit()}
      disabled={!submitEnabled}
      assessment={true}
    />
  );
}
